/* Accelerator 2.0 - Info prodotto */
(() => {
  if (customElements.get('acc-product-info')) return;

  const MOBILE = window.matchMedia('(max-width: 749px)');

  function formatMoney(cents, format) {
    const value = Math.round(Number(cents) || 0);
    const fmt = (decimals, thousands = ',', decimal = '.') => {
      const fixed = (value / 100).toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      const withThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withThousands + decimal + frac : withThousands;
    };
    const tpl = String(format || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    return tpl.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(0);
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(0, ' ', ',');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmt(2, ' ', '.');
        default: return fmt(2);
      }
    });
  }

  class AccProductInfo extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      try {
        this.data = JSON.parse(this.querySelector('[data-acc-json]').textContent);
      } catch (e) {
        console.error('[Accelerator] Dati prodotto non leggibili', e);
        return;
      }
      this.money = (c) => formatMoney(c, this.data.money);
      this.form = document.getElementById(this.dataset.form);
      this.qty = 1;
      this.discount = 0;

      this.initOptions();
      this.initBundles();
      this.initQuantity();
      this.initGallery();
      this.initDelivery();
      this.initSticky();

      this.variant = this.findVariant() || this.data.variants[0];
      this.update(false);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
    }

    /* ---------- varianti ---------- */
    initOptions() {
      this.optionEls = [...this.querySelectorAll('[data-acc-option]')];
      this.optionEls.forEach((fs) => {
        fs.addEventListener('change', () => {
          this.variant = this.findVariant();
          this.update(true);
        });
      });
    }

    selectedOptions() {
      return this.optionEls.map((fs) => {
        const select = fs.querySelector('[data-acc-select]');
        if (select) return select.value;
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    findVariant() {
      const variants = this.data.variants;
      if (!this.optionEls.length) return variants[0];
      const sel = this.selectedOptions();
      return variants.find((v) => sel.every((val, i) => v.options[i] === val)) || null;
    }

    markAvailability() {
      const sel = this.selectedOptions();
      this.optionEls.forEach((fs, i) => {
        const selected = fs.querySelector('[data-acc-selected]');
        if (selected) selected.textContent = sel[i] || '';
        fs.querySelectorAll('input[type="radio"]').forEach((input) => {
          const test = sel.slice();
          test[i] = input.value;
          const ok = this.data.variants.some((v) => v.available && test.every((val, j) => v.options[j] === val));
          const label = fs.querySelector(`label[for="${input.id}"]`);
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
        const select = fs.querySelector('[data-acc-select]');
        if (select) {
          [...select.options].forEach((opt) => {
            const test = sel.slice();
            test[i] = opt.value;
            const ok = this.data.variants.some((v) => v.available && test.every((val, j) => v.options[j] === val));
            opt.textContent = opt.value + (ok ? '' : ' (esaurito)');
          });
        }
      });
    }

    /* ---------- bundle e quantita ---------- */
    initBundles() {
      this.bundleWrap = this.querySelector('[data-acc-bundles]');
      if (!this.bundleWrap) return;
      this.bundleInputs = [...this.bundleWrap.querySelectorAll('input[type="radio"]')];
      if (!this.bundleInputs.some((i) => i.checked) && this.bundleInputs[0]) this.bundleInputs[0].checked = true;
      const apply = () => {
        const checked = this.bundleInputs.find((i) => i.checked);
        this.bundleInputs.forEach((i) => i.closest('.acc-bundle').classList.toggle('is-selected', i.checked));
        if (!checked) return;
        this.qty = parseInt(checked.value, 10) || 1;
        this.discount = parseInt(checked.dataset.discount, 10) || 0;
      };
      apply();
      this.bundleWrap.addEventListener('change', () => {
        apply();
        this.update(false);
      });
    }

    initQuantity() {
      const block = this.querySelector('[data-acc-qty-block]');
      if (!block) return;
      if (this.bundleWrap) {
        block.closest('.acc-b').hidden = true;
        return;
      }
      const input = block.querySelector('[data-acc-qty-input]');
      const set = (n) => {
        this.qty = Math.max(1, Math.min(999, parseInt(n, 10) || 1));
        input.value = this.qty;
        this.update(false);
      };
      block.querySelectorAll('[data-acc-qty]').forEach((btn) =>
        btn.addEventListener('click', () => set(this.qty + parseInt(btn.dataset.accQty, 10)))
      );
      input.addEventListener('change', () => set(input.value));
    }

    /* ---------- aggiornamento generale ---------- */
    update(fromUser) {
      const v = this.variant;
      const available = !!(v && v.available);
      const q = this.qty;
      const d = this.discount;
      const unit = v ? v.price : 0;
      const base = v ? Math.max(v.compare || 0, v.price) : 0;
      const total = Math.floor((unit * q * (100 - d)) / 100);
      const cmpTotal = base * q;

      // input del form
      if (this.form) {
        const idInput = this.form.querySelector('[data-acc-variant-input]');
        if (idInput) {
          if (v) idInput.value = v.id;
          idInput.disabled = !available;
        }
        const qtyInput = this.form.querySelector('[data-acc-qty-hidden]');
        if (qtyInput) qtyInput.value = q;
      }

      // prezzo
      this.querySelectorAll('[data-acc-price]').forEach((el) => {
        const useTotal = el.dataset.total === 'true';
        const now = useTotal ? total : unit;
        const cmp = useTotal ? cmpTotal : base;
        const save = cmp - now;
        const nowEl = el.querySelector('[data-acc-price-now]');
        const cmpEl = el.querySelector('[data-acc-price-compare]');
        const saveEl = el.querySelector('[data-acc-price-save]');
        if (nowEl) nowEl.textContent = v ? this.money(now) : '—';
        if (cmpEl) {
          cmpEl.textContent = this.money(cmp);
          cmpEl.hidden = !v || save <= 0;
        }
        if (saveEl) {
          saveEl.hidden = !v || save <= 0;
          const amount = saveEl.querySelector('[data-acc-save-amount]');
          const pct = saveEl.querySelector('[data-acc-save-pct]');
          if (amount) amount.textContent = this.money(save);
          if (pct) pct.textContent = cmp > 0 ? Math.round((save / cmp) * 100) : 0;
        }
      });

      // prezzi delle offerte
      if (this.bundleInputs) {
        this.bundleInputs.forEach((input) => {
          const bq = parseInt(input.value, 10) || 1;
          const bd = parseInt(input.dataset.discount, 10) || 0;
          const now = Math.floor((unit * bq * (100 - bd)) / 100);
          const cmp = base * bq;
          const card = input.closest('.acc-bundle');
          const nowEl = card.querySelector('[data-acc-bundle-now]');
          const cmpEl = card.querySelector('[data-acc-bundle-cmp]');
          if (nowEl) nowEl.textContent = this.money(now);
          if (cmpEl) {
            cmpEl.textContent = this.money(cmp);
            cmpEl.hidden = cmp <= now;
          }
        });
      }

      // bottone
      const btn = this.querySelector('[data-acc-atc]');
      if (btn) {
        btn.disabled = !available;
        btn.removeAttribute('aria-disabled');
        const t = btn.querySelector('[data-acc-atc-text]');
        if (t) t.textContent = available ? btn.dataset.text : btn.dataset.soldout;
        const priceWrap = btn.querySelector('[data-acc-atc-price]');
        if (priceWrap) {
          priceWrap.hidden = !available;
          const amount = priceWrap.querySelector('[data-acc-atc-amount]');
          if (amount) amount.textContent = this.money(total);
        }
      }
      if (this.sticky) {
        const sBtn = this.sticky.querySelector('[data-acc-sticky-add]');
        const sText = this.sticky.querySelector('[data-acc-sticky-text]');
        const sPrice = this.sticky.querySelector('[data-acc-sticky-price]');
        if (sBtn) sBtn.disabled = !available;
        if (sText) sText.textContent = available ? this.stickyText : (btn ? btn.dataset.soldout : '');
        if (sPrice) sPrice.textContent = v ? this.money(total) : '';
      }

      // rate
      this.querySelectorAll('[data-acc-inst]').forEach((el) => {
        const n = parseInt(el.dataset.count, 10) || 3;
        const amount = el.querySelector('[data-acc-inst-amount]');
        if (amount) amount.textContent = this.money(Math.floor(total / n));
      });

      // disponibilita
      this.querySelectorAll('[data-acc-stock]').forEach((el) => {
        const textEl = el.querySelector('[data-acc-stock-text]');
        let state = 'in';
        let msg = el.dataset.in;
        if (!available) {
          state = 'out';
          msg = el.dataset.out;
        } else if (v.tracked && el.dataset.low && v.inv > 0 && v.inv <= parseInt(el.dataset.threshold, 10)) {
          state = 'low';
          msg = el.dataset.low.replace('[quantità]', v.inv).replace('[quantita]', v.inv);
        }
        el.dataset.state = state;
        if (textEl) textEl.textContent = msg;
      });

      this.markAvailability();

      if (fromUser && v) {
        if (v.media) this.goToMedia(v.media);
        if (this.dataset.updateUrl === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    /* ---------- galleria ---------- */
    initGallery() {
      this.gallery = this.querySelector('[data-acc-gallery]');
      if (!this.gallery) return;
      this.track = this.gallery.querySelector('[data-acc-track]');
      this.prevBtn = this.gallery.querySelector('[data-acc-prev]');
      this.nextBtn = this.gallery.querySelector('[data-acc-next]');
      this.counter = this.gallery.querySelector('[data-acc-counter]');

      this.gallery.querySelectorAll('[data-acc-goto]').forEach((b) =>
        b.addEventListener('click', () => this.goToIndex(b.dataset.accGoto))
      );
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

      let raf = null;
      this.track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          this.syncGallery();
        });
      }, { passive: true });
      // a fine scorrimento aggiorna sempre (anche se il browser rallenta le animazioni)
      this.track.addEventListener('scrollend', () => this.syncGallery());
      let idle = null;
      this.track.addEventListener('scroll', () => {
        clearTimeout(idle);
        idle = setTimeout(() => this.syncGallery(), 150);
      }, { passive: true });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
      });
      this._onResize = () => this.syncGallery();
      window.addEventListener('resize', this._onResize);
      MOBILE.addEventListener('change', this._onResize);
      this.syncGallery();
    }

    visibleSlides() {
      return [...this.track.children].filter((s) => s.offsetParent !== null || getComputedStyle(s).display !== 'none');
    }

    isSlider() {
      return this.track.scrollWidth > this.track.clientWidth + 2;
    }

    currentSlide() {
      const slides = this.visibleSlides();
      const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      let best = slides[0];
      let bestDist = Infinity;
      slides.forEach((s) => {
        const dist = Math.abs(s.offsetLeft - pad - this.track.scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = s; }
      });
      return best;
    }

    scrollToSlide(slide) {
      if (!slide) return;
      if (this.isSlider()) {
        const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        this.track.scrollTo({ left: slide.offsetLeft - pad, behavior: 'smooth' });
      } else {
        this._forced = slide;
        this.syncGallery();
      }
    }

    goToIndex(index) {
      const slide = this.visibleSlides().find((s) => s.dataset.index === String(index));
      this.scrollToSlide(slide);
    }

    goToMedia(mediaId) {
      const slide = this.visibleSlides().find((s) => s.dataset.mediaId === String(mediaId));
      if (slide) this.scrollToSlide(slide);
    }

    step(dir) {
      const slides = this.visibleSlides();
      const i = slides.indexOf(this.currentSlide());
      const next = slides[Math.max(0, Math.min(slides.length - 1, i + dir))];
      this.scrollToSlide(next);
    }

    syncGallery() {
      if (!this.track) return;
      const slides = this.visibleSlides();
      if (!slides.length) return;
      const current = this.isSlider() ? this.currentSlide() : this._forced || slides[0];
      const pos = slides.indexOf(current);
      const idx = current.dataset.index;

      this.gallery.querySelectorAll('[data-acc-goto]').forEach((b) => {
        const on = b.dataset.accGoto === idx;
        b.classList.toggle('is-active', on);
        if (on && b.classList.contains('acc-gallery__thumb')) {
          const box = b.parentElement;
          if (box.scrollWidth > box.clientWidth) {
            const target = b.offsetLeft - box.clientWidth / 2 + b.clientWidth / 2;
            box.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
          } else if (box.scrollHeight > box.clientHeight) {
            const target = b.offsetTop - box.clientHeight / 2 + b.clientHeight / 2;
            box.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
          }
        }
      });
      if (this.counter) this.counter.textContent = `${pos + 1} / ${slides.length}`;
      if (this.prevBtn) this.prevBtn.disabled = pos <= 0;
      if (this.nextBtn) this.nextBtn.disabled = pos >= slides.length - 1;

      if (this.isSlider()) {
        this.track.querySelectorAll('video').forEach((vid) => {
          if (!current.contains(vid) && !vid.paused) vid.pause();
        });
      }
    }

    /* ---------- date di consegna ---------- */
    initDelivery() {
      const el = this.querySelector('[data-acc-delivery]');
      if (!el) return;
      const skipWeekend = el.dataset.skipWeekend === 'true';
      const cutoff = parseInt(el.dataset.cutoff, 10);
      const lang = document.documentElement.lang || 'it';
      const opts = {
        short: { day: 'numeric', month: 'short' },
        long: { day: 'numeric', month: 'long' },
        numeric: { day: '2-digit', month: '2-digit' },
      }[el.dataset.format] || { day: 'numeric', month: 'short' };
      let fmt;
      try { fmt = new Intl.DateTimeFormat(lang, opts); } catch (e) { fmt = new Intl.DateTimeFormat('it', opts); }

      const today = new Date();
      const late = !isNaN(cutoff) && today.getHours() >= cutoff;
      const isOff = (d) => skipWeekend && (d.getDay() === 0 || d.getDay() === 6);
      const addDays = (n) => {
        const d = new Date(today);
        let left = n + (late ? 1 : 0);
        if (n === 0) return d;
        while (left > 0) {
          d.setDate(d.getDate() + 1);
          if (!isOff(d)) left--;
        }
        return d;
      };
      const label = (d) => fmt.format(d).replace('.', '');

      el.querySelectorAll('.acc-delivery__step').forEach((step) => {
        const from = parseInt(step.dataset.from, 10) || 0;
        const to = Math.max(from, parseInt(step.dataset.to, 10) || 0);
        const out = step.querySelector('[data-acc-date]');
        if (!out) return;
        out.textContent = from === to ? label(addDays(from)) : `${label(addDays(from))} – ${label(addDays(to))}`;
      });
    }

    /* ---------- barra fissa ---------- */
    initSticky() {
      this.sticky = this.querySelector('[data-acc-sticky]');
      const mainBtn = this.querySelector('[data-acc-atc]');
      if (!this.sticky || !mainBtn) return;
      const sText = this.sticky.querySelector('[data-acc-sticky-text]');
      this.stickyText = sText ? sText.textContent : '';
      this.sticky.hidden = false;

      // Visibile quando il bottone principale e' passato sopra lo schermo.
      const check = () => {
        const rect = mainBtn.getBoundingClientRect();
        this.sticky.classList.toggle('is-visible', rect.bottom < 0);
      };
      this._io = new IntersectionObserver(check);
      this._io.observe(mainBtn);
      let raf = null;
      this._onScroll = () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { raf = null; check(); });
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      check();

      const sBtn = this.sticky.querySelector('[data-acc-sticky-add]');
      if (sBtn) {
        sBtn.addEventListener('click', () => {
          if (mainBtn.disabled || !this.form) return;
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(mainBtn);
          else mainBtn.click();
        });
      }
    }
  }

  customElements.define('acc-product-info', AccProductInfo);
})();
